import BankCurrencies from "../basics/bankCurrencies";
const Refound = {
    template: ` <h3>${langhelp.refund.title}</h3>
                <div v-if="error">
                        <p v-text="error" style="color:red;"></p>
                </div>
                <div class="pure-g">
                    <h3 class="pure-u-1 pure-u-md-2-5 fs-6 mt-0">${langhelp.refund.type}</h3>
                    <div class="pure-u-1 pure-u-md-3-5 mb-4">
                        <select class="w-100" v-model="inputs.selectedId">
                            <option v-for="(o,i) in types" :value="o.id" :key="i">{{o.need_bank_details ? "${langhelp.refund.bank_transfer}" : o?.method_translation}}</option>
                        </select>
                    </div>
                    <h3 class="pure-u-1 pure-u-md-2-5 fs-6 mt-0" v-show="showBankDetails">${langhelp.refund.bank_details}</h3>
                    <div class="pure-u-1 pure-u-md-3-5 mb-4" v-show="showBankDetails">
                        <div class="form-group w-100" v-for="(label,key) in inputFileds" :key="key">
                            <label :for="'input-'+key">{{label}}</label>
                            <input :id="'input-'+key" type="text" v-model="inputs[key]">
                         </div>
                         <p>${langhelp.refund.bank_help.replace(':currency',currency)}</p>
                    </div>
                    <h3 class="pure-u-1 pure-u-md-2-5 fs-6 mt-0" v-show="!showBankDetails">{{activeMethod?.method_translation}}</h3>
                    <div class="pure-u-1 pure-u-md-3-5 mb-4" v-show="!showBankDetails">
                        <p>${langhelp.refund.other_help}</p>
                        <div></div>
                    </div>
                    <div class="pure-u-1 text-end mb-4">
                        <button class="btn btn-primary" @click="handleSubmit" :class="{'loading-spin':loading}" :disabled="loading"><span>${langhelp.save}</span></button>
                    </div>
                </div>`,
    props:['order-id','order-currency','instant-success'],
    data() {
        return {
            id: null,
            type: 1,
            inputFileds: [],
            orderCurrency: "",
            loading: false,
            inputs:{
                selectedId: "",
            },
            types: [],
            error:null,
        };
    },
    mounted() {
        forms.load();

        this.fetchReturnMethods();
    },
    methods: {
        async fetchReturnMethods() {
            const response = await fetch(`/api/orders/${this.orderId}/returnmethods`, {
                method: "POST",
                headers: http.headers(),
                body:JSON.stringify({token:Cookies.getItem('login_token')})
            }).catch((err) => console.log(err));

            if (!response.ok) {
                console.error("something went wrong fetching api");
                return;
            }
            const return_methods = await response.json();

            this.types = this.transformReturnMethods(return_methods?.data?.methods ?? []);
            this.orderCurrency = return_methods?.data?.currency;

            let hasNoBank = this.types.length > 0 && this.types[0].need_bank_details !== true;
            if(hasNoBank && this.instantSuccess){
                this.$emit('success');
            }

            this.inputs.bank_code = return_methods?.data?.bank_details?.bank_code;
            this.inputs.holder = return_methods?.data?.bank_details?.holder;
            this.inputs.iban = return_methods?.data?.bank_details?.iban;
            this.inputs.number = return_methods?.data?.bank_details?.number;
            this.inputs.transit_code = return_methods?.data?.bank_details?.transit_code;
            if(this.types.length){
                if(BankCurrencies[this.orderCurrency] !== undefined) {
                    this.inputFileds = BankCurrencies[this.orderCurrency].fields;
                }else{
                    this.inputFileds = BankCurrencies["default"].fields;
                }
            }
            setTimeout(() => window.forms.load(),100);
            this.inputs.selectedId = this.types.length ? this.types[0].id : "";
        },
        transformReturnMethods(return_methods) {
            return return_methods.map((method) => {
                let method_translation = "";

                method.returnMethodsTranslations.forEach((translate, index) => {
                    method_translation = translate[window.lan.toUpperCase()]
                        ? translate[window.lan.toUpperCase()].name
                        : Object.values(translate).length
                        ? Object.values(translate)[0].name
                        : "";
                });

                return {
                    ...method,
                    method_translation,
                };
            });
        },
       async handleSubmit(){
            this.loading = true;
            //call api
            const response = await fetch(`/api/orders/${this.orderId}/refound`, {
                method: "POST",
                headers: http.headers(),
                body:JSON.stringify({
                    token:Cookies.getItem('login_token'),
                    return_methods_id:this.inputs.selectedId,
                    crmItemBankAccount:{
                        holder:this.inputs.holder ?? null,
                        number:this.inputs.number ?? null,
                        bank_code:this.inputs.bank_code ?? null,
                        iban:this.inputs.iban ?? null,
                        transit_code:this.inputs.transit_code ?? null,
                    }
                })
            }).catch(err=>{
                console.log(err);
                this.loading = false;
            });
            const data=await response.json();
            this.loading = false;
            if (!response.ok) {
                this.error=data.message;
                return
            }

            this.$emit('success');
        }
    },
    computed: {
        activeMethod() {
            const method = this.types.find(
                (type) => type.id === this.inputs.selectedId
            );
            return method;
        },
        showBankDetails() {
            const method = this.types.find(
                (type) => type.id === this.inputs.selectedId
            );
            return method ? method.need_bank_details : false;
        },
    },
};
export default Refound;
